import Axios from "./axios";

const resource = "partners";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}